import React, { useEffect, useState } from "react";
import "../../Dashboard/AdmDashboard/Dashboard.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdDelete, MdOutlineModeEdit, MdOutlinePendingActions, MdSearch } from "react-icons/md";
import { TbNotes } from "react-icons/tb";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaCalendarDays } from "react-icons/fa6";
import { BsPersonRaisedHand } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import axios from "axios";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Loader from "../../loader/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const AdmDashboard = () => {
  
  const [showModalNew, setShowModalNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [attendanceData, setAttendanceData] = useState([]);
  console.log(attendanceData,"attendanceData");
  const [pendingLeavesData, setPendingLeavesData] = useState("");
  console.log(pendingLeavesData,"pendingLeavesData");
  const [leaveRequest, setLeaveRequest] = useState();
  console.log(leaveRequest,"222leaveRequest");
  const [deleteClickable, setDeleteClickable] = useState("");
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();
    if (searchTerm) {
      const filteredData = leaveRequestDuplicate.filter(item =>
        item?.LeaveTypes?.Name?.toLowerCase()?.includes(searchTerm)
      );
      setLeaveRequest(filteredData);
    }
    else {
      setLeaveRequest(leaveRequestDuplicate);
    }
  };
  const LoginToken = GetToken();
  const navigate = useNavigate();
  // retrieve attendance
  const AttendanceAll = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetToday'sAttendance`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setAttendanceData(data?.Data);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleAttendanceSearch = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setLeaveRequest(data);
        setLeaveRequestDuplicate(data);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        if (
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          RemoveUserSession();
          navigate("/");
        }
      });
  };
  useEffect(() => {
    handleAttendanceSearch();
  }, []);
  // retrieve pending leaves
  const PendingLeaves = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/PendingLeaves`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setPendingLeavesData(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // get percentage
  const todayPresentPercentage =
    (attendanceData?.Present / attendanceData?.Attendance?.length) * 100;
  const leaveTodayPercentage =
    (attendanceData?.Leave / attendanceData?.Attendance?.length) * 100;
  const lateleaveTodayPercentage =
    (attendanceData?.Lateleave / attendanceData?.Attendance?.length) * 100;
  useEffect(() => {
    AttendanceAll();
    PendingLeaves();
  }, []);
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleLeaveDelete = (item) => {
    setDeleteClickable(item);
    setShowModalNew(true);
  };


  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <section
          className={
            showSidebar
              ? "addmin-dashboard-main-container"
              : "addmin-dashboard-main-container-new"
          }
        >
          <div className="all-icons">
            <div>
              <p className="DASHBOARD-MAIN-HEADING">Dashboard </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p>Home </p>
              <MdKeyboardArrowRight />
              <p>Dashboard </p>
            </div>
          </div>
          <div></div>
          <div>
            <div className="dashboard-allcards-flex-container">
              {/*FIRST-CARD/ */}
              <div
                className="admin-dashboard-card"
                onClick={() =>
                  navigate("/Adm/Attendance/TodaysAttendance", {
                    state: "present",
                  })
                }
              >
                <div className="dashboard-img-icon">
                  <BsPersonRaisedHand />
                </div>
                <p className="dashboard-1st-card-heading">
                Today's attendance
                  {/* Today’s attendance <span>(no. of present)</span> */}
                </p>
                <p className="dashboard-number-heading">
                  {attendanceData?.Present ? attendanceData?.Present : "-"}
                </p>
              </div>
              {/*SECOND--CARD/ */}
              <div
                className="dashboard-SECOND-card"
                onClick={() =>
                  navigate("/Adm/Attendance/TodaysAttendance", {
                    state: "absent",
                  })
                }
              >
                <div className="FaCalendarDays-dashboard-img-icon">
                  <FaCalendarDays />
                </div>
                <p className="dashboard-1st-card-heading">
                  Total no of leaves (Today)
                </p>
                <p className="dashboard-number-heading">
                  {attendanceData?.Leave ? attendanceData?.Leave : "-"}
                </p>
              </div>
              {/*SECOND- LAST-CARD/ */}
              <div
                className="dashboard-card-second-last"
                onClick={() =>
                  navigate("/Adm/Attendance/TodaysAttendance", {
                    state: "late",
                  })
                }
              >
                <div className="dashboard-img-icon">
                  <TbNotes />
                </div>
                <p className="dashboard-1st-card-heading">
                  Short leaves (Today)
                </p>
                <p className="dashboard-number-heading">
                  {attendanceData?.Lateleave ? attendanceData?.Lateleave : "-"}
                </p>
                <div className="dashboard-card-img-second-last"></div>
              </div>
              {/* LAST-CARD/ */}
              <div  onClick={()=>navigate("/Emp/EMPLeavesApproval")} className="admin-dashboard-card-last">
                <div className="dashboard-img-icon">
                  <MdOutlinePendingActions />
                </div>
                <p className="dashboard-1st-card-heading">
                Leaves for Approval 
                  {/* Total leaves pending for approval */}
                </p>
                <p className="dashboard-number-heading">
                  {pendingLeavesData ? pendingLeavesData : "-"}
                </p>
              </div>
            </div>
          </div>
          <div className="lower-table-of-admin">

          <div className="EMP-body-part-outer-container">
              <div className="EMP-inner-body-container-of-employee-table row-12">
                <div className=" first-side-in-body-header col-6">
                  <div className="EMP-employee-text-in-body">
                    <h2>Leave Requests</h2>
                  </div>
                  <div className="EMP-input-for-search-in-employee-body">
                    <MdSearch className="EMP-search-icon-in-input" />
                    <input
                      type="text"
                      placeholder="Search by Leave Types"  
                      onChange={(e) => handleDataSearch(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="main-class-for-table-in-admin">
                <table className="table-of-employee-leaves table-of-admin">
                  <thead className="thead-of-emp-table-leaves">
                    <tr className="">
                      <th className="approve_Sr">Sr. No.</th>
                      <th className="approve_Date"> Date</th>
                      <th className="approve_Type">Leave Type</th>
                      <th className="approve_From">Leave From</th>
                      <th className="approve_To">Leave To</th>
                      <th className="approve_Days">No Of Days</th>
                      <th className="approve_Reason">Employee Reason</th>
                      <th className="approve_Status">Status</th>
                      <th className="approve_Reason">Approval Reason</th>
                      <th className="approve_Date">Action</th>
                    </tr>
                  </thead>
                  <tbody className="tbody-ofemp-table-leaves">
                    {leaveRequest?.length ? (
                      <>
                        {leaveRequest?.map((item, index) => (
                          <tr className="" key={index}>
                            <>
                              <td>{index + 1}</td>
                              <td> 
                              {item?.AppliedDate ? moment(item?.AppliedDate).format("DD MMM YYYY") : '-'}
                              </td>
                              <td>
                           
                                {item?.LeaveTypes?.Name}
                              </td>
                              {/* <td>{item?.StartDate.split("T")[0]}</td> */}
                              <td>
                              {item?.StartDate ? moment(item?.StartDate).format("DD MMM YYYY") : '-'}
                              </td>
                              <td>
                              {item?.EndDate ? moment(item?.EndDate).format("DD MMM YYYY") : '-'}
                              </td>
                              <td>  {item?.NumberofDays ? item.NumberofDays : '-'} </td>
                              <td>{item?.Reason ? item?.Reason:'-'}</td>
                              <td>
                                <button
                                  className={
                                    item?.Status === "Cancelled"
                                      ? "EMP-Leaves-table-Pending-button"
                                      : item?.Status === "RejectedByTeamLead" ||
                                        item?.Status === "RejectedByHR" ||
                                        item?.Status === "RejectedByAdmin"
                                        ? "EMP-Leaves-table-Rejected-button"
                                        : item?.Status === "ApprovedByHR" ||
                                          item?.Status === "ApprovedByTeamLead"
                                          ? "EMP-YetToBeApprovedByTeamLead-button"
                                          : item?.Status ===
                                            "YetToBeApprovedByTeamLead"
                                            ? "EMP-YetToBeApprovedByTeamLead-button" : item?.Status === "YetToBeApprovedByAdmin" || item?.Status === "YetToBeApprovedByHR" ? "EMP-YetToBeApprovedByTeamLead-button"
                                              : "EMP-Leaves-table-Approved-button"
                                  }
                                >
                                  {item.Status}
                                </button>
                              </td>
                              <td>
                                {item?.RejectionReason
                                  ? item?.RejectionReason
                                  : "-"}
                              </td>
                              <td className="">
                                {item?.Status ===
                                  "YetToBeApprovedByTeamLead" ? (
                                  <>
                                    <MdOutlineModeEdit
                                      className="handel-Edit-button"
                                      onClick={() =>
                                        navigate("/Emp/ApplyLeaves", {
                                          state: { leaveRequestData: item },
                                        })
                                      }
                                    />
                                    <MdDelete
                                      className="handel-delete-button"
                                      onClick={() => handleLeaveDelete(item)}
                                    />
                                  </>
                                ) : item?.Status === "YetToBeApprovedByAdmin" || item?.Status === "YetToBeApprovedByHR" ?
                                  <>
                                    <MdOutlineModeEdit
                                      className="handel-Edit-button"
                                      onClick={() =>
                                        navigate("/Emp/ApplyLeaves", {
                                          state: { leaveRequestData: item },
                                        })
                                      }
                                    />
                                    <MdDelete
                                      className="handel-delete-button"
                                      onClick={() => handleLeaveDelete(item)}
                                    />
                                  </> : null
                                }
                              </td>
                            </>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr className="no-record-found-tr">
                          <td colSpan="10">No record found</td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
                <div></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default AdmDashboard;